import React from 'react';
import { graphql } from 'gatsby';
import { BlogPost } from '@bluefin/components';

import './DefaultBlogPost.css';

export default function DefaultBlogPost({ data }) {
  const {
    fishermanBusinessBlogPost: {
      title,
      publishedAt,
      gatsbyHeroImage,
      author,
      content,
      summary,
    },
  } = data;

  return (
    <div className="default-blog-wrapper">
      <BlogPost
        title={title}
        heroImage={gatsbyHeroImage && gatsbyHeroImage.childImageSharp}
        publishedAt={publishedAt}
        author={author}
        content={content}
        summary={summary}
        markdown
      />
    </div>
  );
}

export const query = graphql`
  query($id: Int!) {
    fishermanBusinessBlogPost(_id: { eq: $id }) {
      _id
      slug
      summary
      title
      content
      gatsbyHeroImage {
        childImageSharp {
          fluid(maxWidth: 1000) {
            aspectRatio
            base64
            src
            srcSet
          }
        }
      }
      author {
        firstName
        lastName
        avatar
        email
      }
      publishedAt
    }
  }
`;
